<template>
  <div class="w-full bg-gray-50 shadow rounded my-4 p-4">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-sm font-bold ml-4">Slide {{ parseInt(index) + 1 }}</h3>
      <button
        @click="handleDelete(parseInt(index))"
        type="button"
        class="bg-white text-gray active:bg-white-600 font-bold uppercase text-xs px-3 py-1 rounded-full shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
      >
        <IconDelete />
      </button>
    </div>
    <div class="w-full lg:w-4/12 ml-4">
      <SelectField v-model="instanceId" :options="slideOptions" />
    </div>
    <div v-if="instanceId">
      <ImageSlideUpdateForm
        :formData="formData[index]"
        :index="index"
        :instanceId="instanceId"
        :instanceData="getSlideInstance"
        :allSlideAttrbutes="getSlideAttribute"
        @update:formData="handleUpdateFormData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconDelete from "@/assets/icons/IconDelete";
import ImageSlideUpdateForm from "@/components/ComponentModule/ImageSlideComponent/ImageSlideUpdateForm";
import SelectField from "@/components/Shared/Input/SelectField";

export default {
  name: "SlidePanel",
  components: {
    SelectField,
    IconDelete,
    ImageSlideUpdateForm
  },
  props: {
    index: {
      type: String,
      required: true
    },
    slideOptions: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    handleDelete: {
      type: Function,
      required: true
    }
  },
  computed: {
    instanceId: {
      get: function () {
        if (
          this.$router.currentRoute.value.fullPath
            .split("/")
            .includes("create") &&
          this.operationMode === "create"
        ) {
          return this.formDataLocal.slider.attributes.slides[
            parseInt(this.index)
          ].instance;
        } else {
          return this.formDataLocal.slider.slides[parseInt(this.index)]
            .instance;
        }
      },
      set: function (val) {
        if (
          this.$router.currentRoute.value.fullPath
            .split("/")
            .includes("create") &&
          this.operationMode === "create"
        ) {
          this.formDataLocal.slider.attributes.slides[
            parseInt(this.index)
          ].instance = parseInt(val);
        } else {
          this.formDataLocal.slider.slides[parseInt(this.index)].instance =
            parseInt(val);
        }
      }
    },
    slideAttrbutes() {
      if (this.getSlideAttribute) {
        const result = {};
        Object.keys(this.getSlideAttribute).forEach((item) => {
          if (item !== "hotspots") {
            result[item] = this.getSlideAttribute[item];
          }
        });
        return result;
      }
      return {};
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    ...mapGetters([
      "getAllComponent",
      "getSlideLoading",
      "getSlideAttribute",
      "getSlideInstance",
      "operationMode"
    ])
  },
  methods: {
    getComponentId(name) {
      const foundItem = this.getAllComponent.find((item) => item.name === name);
      if (foundItem) {
        return foundItem.id;
      } else {
        return null;
      }
    },
    handleUpdateFormData(val) {
      this.formDataLocal[this.index] = val;
    }
  }
};
</script>
